import { Navigate, RouteObject } from "react-router-dom";

const MeSettingsRoute: RouteObject = {
    path: "",
    children: [
        {
            index: true,
            element: <Navigate to="mon-compte" replace />
        },
        {
            path: "mon-compte",
            async lazy() {
                let { MeSettings } = await import("@/pages/settings/me");
                return { Component: MeSettings };
            }
        }
    ]
};

export default MeSettingsRoute;
